import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Col,
  InputGroup,
  Dropdown
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SubcategoryService from '../../service/SubcategoryService';
import LocationService from '../../service/LocationService';
import SaleAd from '../../assets/new_sale_banner.webp';

const AdListingHeader = ({ initialLocation, initialSubcategoryId }) => {
  const [location, setLocation] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedShopType, setSelectedShopType] = useState('');
  const [showSubcategory, setShowSubcategory] = useState(false);

  const subcategoryRef = useRef(null);
  const locationRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    setLocation(initialLocation?.location || '');
  }, [initialLocation]);

  useEffect(() => {
    fetchSubcategories();
  }, []);

  // ✅ Outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        subcategoryRef.current &&
        !subcategoryRef.current.contains(event.target)
      ) {
        setShowSubcategory(false);
      }

      if (
        locationRef.current &&
        !locationRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () =>
      document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (subcategories.length > 0 && initialSubcategoryId) {
      const matchedSubcategory = subcategories.find(
        (sub) => sub.id == initialSubcategoryId
      );
      if (matchedSubcategory) {
        setSelectedSubcategory(matchedSubcategory.name);
      }
    }
  }, [subcategories, initialSubcategoryId]);

  const fetchSubcategories = async () => {
    try {
      const response =
        await SubcategoryService.getSubcategoriesByCategory();
      setSubcategories(response);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    }
  };

  const handleLocationChange = async (e) => {
    const newLocation = e.target.value;
    setLocation(newLocation);

    if (newLocation.length >= 3) {
      try {
        const response =
          await LocationService.getLocationByName(newLocation);
        setLocationSuggestions(response);
        setShowSuggestions(true);
      } catch (error) {
        console.error('Error fetching location suggestions:', error);
      }
    } else {
      setShowSuggestions(false);
    }
  };

  const handleLocationSelect = (selectedLocation) => {
    setLocation(selectedLocation.location);
    setShowSuggestions(false);
  };

  const handleSubcategorySelect = (subcategory) => {
    setSelectedSubcategory(subcategory);
    setShowSubcategory(false);
  };

  const handleSearch = () => {
    const selectedSubcategoryData = subcategories.find(
      (sub) => sub.name === selectedSubcategory
    );

    if (selectedSubcategoryData) {
      sessionStorage.setItem(
        'subcategoryId',
        selectedSubcategoryData.id
      );
    }

    sessionStorage.setItem('shopType', selectedShopType);

    const formattedSubcategory = selectedSubcategory
      .trim()
      .replace(/\s+/g, '-');

    const searchlocation = location
      .trim()
      .replace(/,\s*/g, '-');

    const url = `/${formattedSubcategory}/service-near-me/${searchlocation}`;
    navigate(url.toLowerCase());
  };

  return (
    <div className="ad-listing-header">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <div className="internal_search-style">

          {/* Service */}
          <Col
            md={12}
            className="internal_category_search"
            ref={subcategoryRef}
          >
            <h5 className="input_tit">Select Service</h5>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Choose Service"
                value={selectedSubcategory}
                onClick={() =>
                  setShowSubcategory((prev) => !prev)
                }
                readOnly
              />
            </InputGroup>

            {showSubcategory && (
              <Dropdown.Menu show className="c-width">
                {subcategories.map((subcategory) => (
                  <Dropdown.Item
                    key={subcategory.id}
                    onClick={() =>
                      handleSubcategorySelect(subcategory.name)
                    }
                  >
                    {subcategory.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            )}
          </Col>

          {/* Location */}
          <Col
            md={12}
            className="internal_location"
            ref={locationRef}
          >
            <h5 className="input_tit">Location</h5>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Enter your city, state"
                value={location}
                onChange={handleLocationChange}
              />
              <Button variant="outline-secondary">
                <i
                  className="fas fa-location-dot"
                  title="location"
                ></i>
              </Button>
            </InputGroup>

            {showSuggestions && (
              <Dropdown.Menu show className="c-width">
                {locationSuggestions.map((suggestion, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() =>
                      handleLocationSelect(suggestion)
                    }
                  >
                    {suggestion.location}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            )}
          </Col>

          {/* Work Type */}
          <Col md={12} className="internal_workType">
            <h5 className="input_tit">Work Type</h5>
            <Form.Control
              as="select"
              value={selectedShopType}
              onChange={(e) =>
                setSelectedShopType(e.target.value)
              }
            >
              <option value="">Shop/Mobile</option>
              <option value="Shop">Shop</option>
              <option value="Mobile">Mobile</option>
            </Form.Control>
          </Col>

          {/* Search */}
          <Col md={12} className="search_btn">
            <Button variant="primary" className="btn-block" type="submit">
              <i className="fa fa-search" /> Search
            </Button>
          </Col>

          {/* Sale Ad */}
          <Col md={12} className="sidebar_saleAd mt-5">
            <div>
              <a href="tel:1234567890">
                <img
                  src={SaleAd}
                  className="img-fluid rounded"
                  alt="Special Offer"
                />
              </a>
            </div>
          </Col>

        </div>
      </Form>
    </div>
  );
};

export default AdListingHeader;
